/**
 * US IANA timezone options for AIVSelect dropdowns.
 * Each entry has { id, name } matching AIVSelect's expected format.
 */
export const TIMEZONE_OPTIONS = [
  { id: "America/New_York", name: "Eastern Time (America/New_York)" },
  { id: "America/Chicago", name: "Central Time (America/Chicago)" },
  { id: "America/Denver", name: "Mountain Time (America/Denver)" },
  { id: "America/Phoenix", name: "Arizona Time (America/Phoenix)" },
  { id: "America/Los_Angeles", name: "Pacific Time (America/Los_Angeles)" },
  { id: "America/Anchorage", name: "Alaska Time (America/Anchorage)" },
  { id: "Pacific/Honolulu", name: "Hawaii Time (Pacific/Honolulu)" },
  { id: "America/Boise", name: "Mountain Time (America/Boise)" },
  { id: "America/Indiana/Indianapolis", name: "Eastern Time (America/Indiana/Indianapolis)" },
  { id: "America/Detroit", name: "Eastern Time (America/Detroit)" },
];

/**
 * Returns the current user's browser IANA timezone.
 * @returns {string} e.g. "America/Denver"
 */
export function getBrowserTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

/**
 * Returns a human-readable label for an IANA timezone string.
 * @param {string} iana - IANA timezone (e.g., "America/Denver")
 * @returns {string} e.g. "Mountain Time (America/Denver)"
 */
export function formatTimezoneLabel(iana) {
  if (!iana) return "";
  const match = TIMEZONE_OPTIONS.find((opt) => opt.id === iana);
  if (match) return match.name;
  // Fallback: format the IANA string nicely
  const city = iana.split("/").pop().replace(/_/g, " ");
  return `${city} (${iana})`;
}
